import { ELogEntryInputSignificance } from 'motw_core/LogEntry/ELogEntryInputSignificance';
import * as React from 'react';
import { FormSelect } from 'source/app/presentation/Shared/Form/Select/FormSelect';
import { OnLogInputFormControlFocus } from '../LogInputForm';
import { HandleAddLogEntryChange } from '../LogInputFormHelpers';

export const SignificanceSelector = ({
	significance,
	onDefocus
}: {
	significance: string;
	onDefocus: ((event: React.FocusEvent<HTMLSelectElement>) => void);
}) => (
	<FormSelect
		id="inpSignificance"
		minWidth="125px"
		maxWidth="125px"
		value={significance}
		suggestions={GetSignificanceSuggestions()}
		onChange={(event) => HandleAddLogEntryChange('inpSignificance', event.target.value)}
		onFocus={() => OnLogInputFormControlFocus()}
		onDefocus={onDefocus}
		dynamicOpacity
	/>
);

// Note: changing the order of elements in this array
// could break GetLogFormValues()
export const GetSignificanceSuggestions = () => [
	ELogEntryInputSignificance[ELogEntryInputSignificance.Important],
	ELogEntryInputSignificance[ELogEntryInputSignificance.Monumental]
];


